import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { DeleteProviderTaskDataForm } from '@/components/forms/DeleteProviderTaskDataForm/DeleteProviderTaskDataForm'
import { DeleteProviderTaskDataFormFields } from '@/components/forms/DeleteProviderTaskDataForm/DeleteProviderTaskDataFormFields'

export interface DeleteProviderTaskDataModalProps extends DialogProps {
  dates: {
    st_dt: string
    ed_dt: string
  }
}

export const DeleteProviderTaskDataModal: React.FC<DeleteProviderTaskDataModalProps> = ({
  dates,
  ...props
}) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <DeleteProviderTaskDataForm>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Delete provider data</DialogTitle>
                  <DialogDescription>Select a task and value date to continue.</DialogDescription>
                </DialogHeader>
                <div className="my-6">
                  <DeleteProviderTaskDataFormFields dates={dates} />
                </div>
                <DialogFooter>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </DeleteProviderTaskDataForm>
      </DialogContent>
    </Dialog>
  )
}
